import Plugin from '../core/Plugin';
import * as SelectionUtils from '../SelectionUtils';

/**
 * BlockFormattingPlugin - Handles headings and paragraph formatting
 */
class BlockFormattingPlugin extends Plugin {
  constructor(editor, options = {}) {
    super(editor, options);
    this.name = 'BlockFormatting';
  }

  getToolbarButtons() {
    return [
      {
        name: 'blocks',
        buttons: [
          { command: 'formatBlock:h1', label: 'H1', title: 'Heading 1' },
          { command: 'formatBlock:h2', label: 'H2', title: 'Heading 2' },
          { command: 'formatBlock:h3', label: 'H3', title: 'Heading 3' },
          { command: 'formatBlock:p', label: 'P', title: 'Paragraph' },
        ],
      },
    ];
  }

  executeCommand(command) {
    if (command.startsWith('formatBlock:')) {
      const tag = command.split(':')[1];
      SelectionUtils.formatBlock(tag);
    }
  }

  getMetadata() {
    return {
      name: 'Block Formatting',
      version: '1.0.0',
      description: 'Provides heading and paragraph block formatting',
      author: 'AtlaraFirm',
    };
  }
}

export default BlockFormattingPlugin;
